export default class HospitalSearchMessage {
  // static TreatmentsMaxCountAlert = '病名/診療科/検査名/治療名は5つまで指定できます。'
  static TreatmentsMaxCountAlert = '診療科/検査名/治療名は5つまで指定できます。'
}
